import classNames from 'classnames';

import { Classes } from 'types/Classes';

import classes from './InputNumber.module.scss';

type Mode = 'integer' | 'float';

type Props = {
  id?: string;
  name?: string;
  value?: string | number;
  placeholder?: string;
  suffix?: string;
  isWrong?: boolean;
  mode?: Mode;
  classes?: Classes<'root' | 'suffix'>;
  onChange?: (value: number | string) => void;
};

const InputNumber = ({
  id,
  name,
  value,
  mode = 'integer',
  placeholder,
  suffix,
  isWrong = false,
  classes: customClasses,
  onChange = () => {},
}: Props): JSX.Element => {
  const isInputValid = !isWrong;

  return (
    <div className={classNames(classes.wrapper, customClasses?.root)}>
      <input
        id={id}
        name={name}
        type={mode === 'integer' ? 'phone' : 'number'}
        inputMode="numeric"
        autoComplete="off"
        className={classNames(classes.input, {
          [classes.hasError]: !isInputValid,
          [classes.filled]: value,
        })}
        value={value}
        onChange={(e) => {
          const parseFunction = mode === 'integer' ? parseInt : parseFloat;
          const parsedValue = parseFunction(e.target.value);
          onChange(!Number.isNaN(parsedValue) ? parsedValue : '');
        }}
        placeholder={placeholder}
      />
      {suffix && (
        <div className={classNames(classes.suffix, customClasses?.suffix, { [classes.activeSuffix]: !!value })}>
          {suffix}
        </div>
      )}
    </div>
  );
};

export default InputNumber;
